<template>
  <div>
    <transition name="slide" mode="out-in">
      <router-view :con="con" />
    </transition>

    <!-- ContactModal global -->
    <ContactModal />

    <!-- PricingModal global -->
    <PricingModal />
  </div>
</template>

<script>
import { onMounted, watch } from 'vue'
import { useRoute } from 'vue-router'
import ContactModal from '@/components/modal/Contact.vue'
import PricingModal from '@/components/modal/Pricing.vue'

export default {
  name: 'sitio',
  components: {
    ContactModal,
    PricingModal
  },
  props: {
    con: {
      default: {},
      type: Object
    }
  },
  setup() {
    const route = useRoute()

    const updateBodyMargin = () => {
      const path = route.path
      const isSpecialPage = path.startsWith('/t/') || path.startsWith('/l/')
      document.body.style.marginTop = isSpecialPage ? '0' : '10px'
    }

    onMounted(updateBodyMargin)
    watch(route, updateBodyMargin)
  }
}
</script>

<style lang="scss">
body {
  transition: margin-top 0.3s ease;
}

.slide-enter-active,
.slide-leave-active {
  transition: all 0.5s ease;
  position: absolute;
  width: 100%;
}

.slide-enter-from {
  transform: translateX(100%);
  opacity: 0;
}

.slide-leave-to {
  transform: translateX(-100%);
  opacity: 0;
}
</style>
